import { reactive, computed } from 'vue'
import { createAuthenticationService } from '@/services/authenticationService'

// TODO: this could be a pinia store
const authPlugin = {
    isAuthenticated: computed(() => !!state.user),
    user: computed(() => state.user),
    setUser: (user) => {
        state.user = user;
    },
    openLoginDialog: (callback: () => any | null, loginOptions) => {
        state.flow?.openLoginDialog(callback, loginOptions);
    },
    openRegistrationDialog: (callback: () => any | null, loginOptions) => {
        state.flow?.openRegistrationDialog(callback, loginOptions);
    },
    registerFlow: (flow) => {
        state.flow = flow;
    },
    updateFlowState: () => {
        state.flow?.updateState();
    }
}
const flow: any = null;

const state = reactive({
    user: {},
    // flow is the LoginRegistrationFlow Component
    // only methods from defineExpose are available here
    flow: flow
});

export const setupAuth = () => {

    return {
        install: (app) => {
            const service = createAuthenticationService(app);
            authPlugin.setUser(service.getUser());
            app.config.globalProperties.$auth = authPlugin;
        },
    }
}

export const isUserAuthenticated = () => {

    const { isAuthenticated } = authPlugin;

    return isAuthenticated.value;
};

